__turbopack_context__.v({
  "className": "englebert_e5d4131d-module__9sMvaq__className",
});
